import { ulidSchema } from "schemas/commonSchema";
import { z } from "zod";

export const scheduleSchema = z.object({
  scheduleName: z.string().min(1).max(50),
  dayOfWeek: z.string(),
  time: z.date(),
  mapId: ulidSchema,
  memo: z.string().optional(),
  cleaningSettings: z.record(z.string(), z.string()),
});

export type ScheduleFormInput = z.infer<typeof scheduleSchema>;

export type MapOption = {
  mapId: string;
  mapName: string;
};
